export default __webpack_public_path__ + "static/media/balkantravel.d2f17429.png";